<template>
  <div class="boxbox">
    <div class="screening">
      <div class="province">
        <p class="onlyprovince title onlyprovince1">所在省份</p>
        <p class="onlyprovince unlimited">
          <span
            @click="onprovincefun"
            class="onlyprovince1 onlyprovince"
            :class="provinceflag ? 'provinceactive' : ''"
            >不限</span
          >
        </p>
        <div class="provincebox">
          <p
            v-for="(item, index) in address"
            :key="index"
            class="onlyprovince onlyprovince1"
            :class="item.flag ? 'provinceactive' : ''"
            @click="onMaterial(item)"
          >
            {{ item.codeRemark }}
          </p>
        </div>
      </div>
      <div class="ruleForm">
        <el-form
          class="myform"
          :model="ruleForm"
          status-icon
          ref="ruleForm"
          label-width="96px"
          size="mini"
          label-suffix=":"
        >
          <el-form-item
            label="处置企业"
            prop="publicCompName"
            class="inputonly"
          >
            <el-input
              v-model="ruleForm.publicCompName"
              autocomplete="off"
              class="inputonly1"
            ></el-input>
          </el-form-item>
          <el-form-item label="预告标题" prop="pass" class="inputonly">
            <el-input
              v-model="ruleForm.title"
              autocomplete="off"
              class="inputonly1"
            ></el-input>
          </el-form-item>
          <el-form-item label="预告编号" prop="pass" class="inputonly">
            <el-input
              v-model="ruleForm.code"
              autocomplete="off"
              class="inputonly1"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="submit">
          <p class="query" @click="onQuery">查询</p>
          <p class="cancel" @click="onClear">清除</p>
        </div>
      </div>
    </div>
    <DisposalNotice ref="auctions" :param="ruleForm" :flag="true" />
  </div>
</template>
<script>
export default {
  name: 'Biddingsession',
  data() {
    return {
      resultunlimitedflag: true,
      provinceflag: true,
      biddingconditionlist: [
        { name: '成交', flag: false },
        { name: '未成交', flag: false }
      ],
      address: [],
      ruleForm: {
        code: '',
        title: '',
        proviceCode: '',
        pageSize: 10,
        pageNum: 1,
        publicCompName: ''
      }
    }
  },
  computed: {
    type() {
      return this.$route.query.type
    }
  },

  created() {
    this.getProvinces()
  },
  methods: {
    onClear() {
      this.ruleForm.code = ''
      this.ruleForm.title = ''
      this.ruleForm.publicCompName = ''
      this.provinceflag = false
      this.onprovincefun()
      this.getList()
    },
    getList() {
      setTimeout(() => {
        this.$refs.auctions.getNoticeList()
      }, 100)
    },
    onprovincefun() {
      if (!this.provinceflag) {
        this.provinceflag = true
        this.address.map(item => {
          item.flag = false
        })
        this.ruleForm.proviceCode = ''
      }
      this.getList()
    },
    onMaterial(item) {
      console.log(item)
      item.flag = !item.flag
      console.log(this.address)
      let ids = []
      this.provinceflag = !this.address.some(item => {
        return item.flag
      })
      this.address.map(item => {
        if (item.flag) {
          ids.push(item.cityCode)
        }
      })
      const applyIds = ids.join(',')
      console.log(applyIds)
      this.ruleForm.proviceCode = applyIds
      this.getList()
    },
    onQuery() {
      console.log(this.ruleForm)
      this.getList()
    },
    // 首页获取地点数据
    async getProvinces() {
      let res = await this.$api.notice.getProvinces()
      res.data.map(item => {
        item.flag = false
      })
      this.address = res.data
    }

    // currentPage1: 5,
    // currentPage2: 5,
    // currentPage3: 5,
    // currentPage4: 4
  }
}
</script>
<style lang="less" scoped>
.boxbox {
  background: transparent !important;
}
.screening {
  background: #ffffff;
  width: 1200px;
  min-height: 150px;

  padding: 20px 20px 20px 20px;
  margin-bottom: 20px;
  margin-top: 20px;
  .material {
    padding-bottom: 23px;
    border-bottom: 1px solid #dcdcdc;
    display: flex;
    .title {
      //   margin-right: 20px;
      margin-top: 0 !important;
      line-height: unset !important;
    }
    .only {
      margin-right: 20px;
      cursor: pointer;
      font-family: 'Source Han Sans CN';
      font-style: normal;
      font-weight: 350;
      font-size: 14px;
      line-height: 14px;
      /* identical to box height, or 100% */

      /* 灰色/文字/Gy8-#333333 */

      color: #333333;
    }
  }
  .province {
    border-bottom: 1px solid #dcdcdc;
    padding-bottom: 4px;
    display: flex;
    // padding-top: 20px;
    // flex-wrap: wrap;
    .title {
      //   margin-right: 10px;
      //   margin-top: 15px;
      display: inline-block;
      margin-top: 0 !important;
      line-height: unset !important;
    }
    .only {
      display: inline-block;
      margin-right: 20px;
      cursor: pointer;
      font-family: 'Source Han Sans CN';
      font-style: normal;
      font-weight: 350;
      font-size: 14px;
      line-height: 14px;
      /* identical to box height, or 100% */

      /* 灰色/文字/Gy8-#333333 */

      color: #333333;
      margin-bottom: 20px;
    }

    .provincebox {
      display: flex;
      flex-wrap: wrap;
      display: inline-block;
      width: 1015px;
      //   background: #333333;
    }
  }
}
.some {
  padding-top: 20px;
  //   margin-bottom: 20px;
}
/deep/.inputonly {
  .el-form-item__label {
    font-family: 'Source Han Sans CN';
    font-style: normal;
    font-weight: 350;
    font-size: 14px;
    line-height: 28px;
    /* identical to box height, or 100% */

    /* 灰色/文字/Gy8-#333333 */

    color: #333333;
  }
}
/deep/.inputonly1 {
  .el-input__inner {
    width: 280px;
    height: 30px;
    border-radius: 0px;
  }
}
.submit {
  width: 100%;
  display: flex;
  justify-content: flex-end;

  .cancel {
    display: inline-block;
    width: 80px;
    height: 30px;
    border: 1px solid #d9d9d9;
    margin-left: 10px;
    font-family: 'Source Han Sans CN';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 30px;
    /* identical to box height, or 100% */

    /* 灰色/文字/Gy8-#333333 */

    color: #333333;
    text-align: center;
    cursor: pointer;
  }
  .query {
    display: inline-block;
    width: 80px;
    cursor: pointer;
    height: 30px;
    background: #2587ff;
    font-family: 'Source Han Sans CN';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 30px;
    /* identical to box height, or 100% */

    /* 灰色/文字/Gy8-#333333 */

    color: #ffffff;
    text-align: center;
  }
}
/deep/.el-input__inner {
  border: 1px solid #dcdfe6 !important;
  font-family: MicrosoftYaHeiLight;
}
.onlyactive {
  color: #2587ff !important;
}
.provinceactive {
  background: #2587ff;
  border-radius: 16px;
  color: #ffffff !important;
}
.onlyprovince:hover {
  color: #2587ff;
}
.onlyprovince {
  display: inline-block;

  //   margin-right: 16px;
  cursor: pointer;
  font-family: 'Source Han Sans CN';
  font-style: normal;
  font-weight: 350;
  font-size: 14px;
  line-height: 14px;
  /* identical to box height, or 100% */

  /* 灰色/文字/Gy8-#333333 */

  color: #333333;
}
.onlyprovince1 {
  padding: 4px 5px;
  //   margin-top: 15px;
  margin-left: 15px;
  margin-bottom: 16px;
}
.unlimited {
  //   padding-top: 15px;
}

.ruleForm {
  padding-top: 20px;
}
/deep/.more {
  position: static !important;
}
/deep/.el-pagination {
  text-align: right !important;
}
/deep/.active {
  background-color: #2587ff !important;
  color: #2587ff !important;
}
/deep/.number {
  border: 1px solid #d9d9d9;
  background-color: #ffffff !important;
}
/deep/.number:hover {
  color: #2587ff !important;
}
/deep/.el-icon-d-arrow-right {
  color: #2587ff !important;
}
/deep/.el-icon-d-arrow-left {
  color: #2587ff !important;
}
/deep/.el-pager li.active + li {
  border: 1px solid #d9d9d9;
}
/deep/.btn-prev {
  border: 1px solid #d9d9d9;
  padding: 0 9px 0 9px !important;
  background-color: #ffffff !important;
}
/deep/.btn-next {
  border: 1px solid #d9d9d9;
  padding: 0 9px 0 9px !important;
  background-color: #ffffff !important;
}

/deep/.btn-quicknext {
  background-color: #ffffff !important;
}
/deep/.btn-quickprev {
  background-color: #ffffff !important;
}
.onlyprovince {
  display: inline-block;
}
.myform {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
}
/deep/ .el-form-item--mini.el-form-item {
  margin-bottom: 0;
}
</style>
